module.exports = __webpack_public_path__ + "img/right.f68576d6.svg";